export enum PayPeriods {
  GET_PAY_PERIODS_REQUEST = '@payperiods/GET_PAY_PERIODS_REQUEST',
  GET_PAY_PERIODS_SUCCESS = '@payperiods/GET_PAY_PERIODS_SUCCESS',
  GET_PAY_PERIODS_FAIL = '@payperiods/GET_PAY_PERIODS_FAIL',
}

export interface IGetPayPeriodsPayload {
  siteId: string;
  orgId: string;
}
